import "./css/reset.css";
import "./css/App.css";
import Header from "./Components/Header";
import Hero from "./Components/Hero";
import ProfileCta from "./Components/ProfileCta";
import GetStarted from "./Components/GetStarted";
import LoanCalculator from "./Components/LoanCalculator";
import Footer from "./Components/Footer";
import WhyUseUs from "./Components/WhyUseUs";

function App() {
  return (
    <div className="App">
      <Header />
      <Hero />
      <ProfileCta />
      <WhyUseUs />
      <GetStarted />
      <LoanCalculator />
      <Footer />
    </div>
  );
}

export default App;
